import { Star } from 'lucide-react';

import { cn } from '@/shared/lib/cn';

/**
 * Nota de 1 a 5 com meia-estrela.
 *
 * `nota === null` é diferente de `nota === 0`: o CHECK do banco só aceita 1..5,
 * então zero não existe. Null significa "ninguém avaliou ainda", e mostrar
 * cinco estrelas apagadas nesse caso passaria a impressão de nota péssima.
 */
export function NotaEstrelas({
  nota,
  total,
  className,
}: {
  nota: number | null;
  total: number;
  className?: string;
}) {
  if (nota === null) {
    return <span className={cn('text-xs text-muted-foreground', className)}>Sem avaliações</span>;
  }

  return (
    <span
      className={cn('inline-flex items-center gap-1', className)}
      aria-label={`Nota ${nota.toFixed(1)} de 5, com ${total} ${total === 1 ? 'avaliação' : 'avaliações'}`}
    >
      <span className="inline-flex" aria-hidden="true">
        {[1, 2, 3, 4, 5].map((posicao) => {
          const preenchimento = Math.max(0, Math.min(1, nota - posicao + 1));
          return (
            <span key={posicao} className="relative inline-block w-3.5 h-3.5">
              <Star className="absolute inset-0 w-3.5 h-3.5 text-muted-foreground/30" />
              <span
                className="absolute inset-0 overflow-hidden"
                style={{ width: `${preenchimento * 100}%` }}
              >
                <Star className="w-3.5 h-3.5 text-amber-500 fill-amber-500" />
              </span>
            </span>
          );
        })}
      </span>
      <span className="text-xs font-medium text-foreground">{nota.toFixed(1)}</span>
      <span className="text-xs text-muted-foreground">({total})</span>
    </span>
  );
}
